/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { DropdownButton, Kbd, Menu, Typography } from '@neo4j-ndl/react';
import { MoonIconOutline, SunIconOutline } from '@neo4j-ndl/react/icons';
import { useRef, useState } from 'react';

const Component = () => {
  const anchorEl = useRef<HTMLButtonElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string | null>(
    'option-1',
  );

  return (
    <>
      <Menu
        isOpen={isOpen}
        anchorRef={anchorEl}
        onClose={(_event, _data) => {
          setIsOpen(false);
        }}
        htmlAttributes={{ id: 'radio-items-menu' }}
      >
        <Menu.RadioItem
          title="Option 1"
          leadingVisual={<SunIconOutline />}
          isChecked={selectedOption === 'option-1'}
          onClick={() => {
            setSelectedOption('option-1');
          }}
        />
        <Menu.RadioItem
          title="Option 2"
          leadingVisual={<MoonIconOutline />}
          isChecked={selectedOption === 'option-2'}
          onClick={() => {
            setSelectedOption('option-2');
          }}
        />
        <Menu.RadioItem
          title="Option 3"
          description="Option 3 has a description"
          isChecked={selectedOption === 'option-3'}
          onClick={() => {
            setSelectedOption('option-3');
          }}
        />
        <Menu.RadioItem
          title="Option 4"
          trailingContent={<Kbd keys={['A']} />}
          isChecked={selectedOption === 'option-4'}
          onClick={() => {
            setSelectedOption('option-4');
          }}
        />
      </Menu>
      <div className="n-flex n-flex-col n-gap-token-4 n-items-center">
        <Typography variant="body-medium">
          Selected option: <strong>{selectedOption}</strong>
        </Typography>
        <DropdownButton
          isOpen={isOpen}
          onClick={() => setIsOpen(true)}
          ref={anchorEl}
          aria-haspopup="menu"
        >
          Open menu
        </DropdownButton>
      </div>
    </>
  );
};

export default Component;
